var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"card-container window-height window-width row justify-center items-center"},[_c('InputCard')],1),_c('Particles')],1)}
var staticRenderFns = []

export { render, staticRenderFns }